<template>
  <v-container fluid>
    <v-alert v-if="showAlert" color="red darken-2" type="error" dense>
      LA SOLICITUD YA NO SE PUEDE EDITAR
    </v-alert>
    <v-row  dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
        <ViewDetails :object="object" type="Solicitudtransferencia" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import { UserSession } from '@/store/modules/config'
import DataTableMain from '@/components/tables/DataTableMain'
import ViewDetails from '@/components/ViewDetails'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'inventariable.solicitudes_transferencia.entry' }
        ],
        titles: [
          { text: 'Folio', value: 'folio', class: 'black--text' },
          { text: 'Fecha', value: 'ObjetDateDinamic', class: 'black--text', showItemColum: 'created_at' },
          { text: 'Solicitante', value: 'solicitante.NombreCompleto', class: 'black--text' },
          { text: 'Num. de Bienes', value: 'NumTransfe', class: 'black--text' },
          { text: 'Tipo de Bien', value: 'transferencias.0.familia.padre.nombre', class: 'black--text' },
          { text: 'Estatus', value: 'Status', class: 'black--text', align: 'center' },
          { text: '', value: 'Actions', align: 'right' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Editar', icon: 'mdi-pencil', color: 'amber darken-2', action: 'updateData', code: 'inventariable.solicitudes_transferencia.entry' },
          { title: 'Solicitud de Transferencia', icon: 'mdi-file-pdf-box', color: 'amber darken-2', action: 'DownloadPdfData', code: 'inventario.transferencias.rpt' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {},
    showAlert: false
  }),
  components: {
    DataTableMain,
    ViewDetails
  },
  mounted () {
    this.user = UserSession()
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects', 'GETExportPdftSerice']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'SET_SERVICES']),
    SuccessTableAction (item) { this[item.action](item) },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjects({ url: router })
      } else {
        this.getUrlServices()
      }
    },
    filterData (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'filter',
        with: '60%',
        title: 'FILTRAR',
        body: {
          objectMain: this.filterTableData,
          paramsDialog: {
            form: this.get_InventariosEquiposFilterForm,
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    },
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    // ==========*==========*==========*==========*==========*==========*==========*==========* \\
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('transferencias.list')
    },
    newData (item) {
      // this.SHOW_DIALOG_MAIN({
      //   type: 'create',
      //   form: 'process',
      //   with: '60%',
      //   title: 'Nuevo Solicitud De Transferencia',
      //   body: {
      //     objectMain: { empresa_id: this.user.empresa_id },
      //     paramsDialog: {
      //       url: this.get_urls['transferencias.execute'],
      //       urloption: this.get_urls['transferencias.options'],
      //       message: 'Registro Agregado Correctamente',
      //       setmodel: true
      //     }
      //   }
      // })
      this.SHOW_DIALOG_MAIN({
        type: 'filtro',
        with: 850,
        title: 'Filtro de Transferencia',
        body: {
          objectMain: {},
          paramsDialog: {
            form: this.get_filter_transferencia,
            message: 'Registro Agregado Correctamente'
          }
        }
      })
    },
    updateData ({ item }) {
      const estatusIds = [66, 68]

      if (estatusIds.includes(item.last_movement.estatus_id)) {
        this.$swal.fire({
          type: 'error',
          icon: 'warning',
          title: 'Advertencia!',
          text: 'El bien ya no se puede editar debido a su estatus actual.'
        })

        return
      }
      const TransferenciasForm = JSON.parse(JSON.stringify(this.get_EditTransferenciasForm))
      TransferenciasForm.map(field => {
        if (field.field === 'TableDataServer') {
          field.data = { transferencias: item.descripcion.transferencias_ids }
        }
      })
      const data = {
        folio: item.folio,
        transferencias: item.descripcion.transferencias_ids
      }

      this.SHOW_DIALOG_MAIN({
        type: 'update',
        with: '75%',
        title: 'Editar Solicitud',
        body: {
          objectMain: data,
          paramsDialog: {
            form: TransferenciasForm,
            url: this.get_urls['transferencias.update'],
            message: 'Registro Agregado Correctamente',
            setmodel: true
          }
        }
      })
    },
    toAssign (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'asign',
        form: 'process',
        with: '70%',
        title: 'Asignacion de Departamento',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['transferencias.execute'],
            urloption: this.get_urls['transferencias.options'],
            message: 'Registro Agregado Correctamente',
            returnObject: true
          }
        }
      })
    },
    toAproved (item) {
      const Copyitem = JSON.parse(JSON.stringify(item))
      let transfer = []
      Copyitem.body.status_finish.formulario.fields.map(field => {
        if (field.field === 'TableDataServer') {
          transfer = item.item.transferencias.map(tans => { return tans.id })
          field.data = { transferencias: transfer }
        }
      })
      const data = {
        folio: item.folio,
        transferencias: transfer
      }
      this.SHOW_DIALOG_MAIN({
        type: 'aproved',
        form: 'process',
        with: '60%',
        title: 'Bienes a Transferir',
        body: {
          objectMain: Copyitem,
          paramsDialog: {
            url: this.get_urls['transferencias.execute'],
            urloption: this.get_urls['transferencias.options'],
            message: 'Registro Agregado Correctamente',
            setmodel: true,
            data: data
          }
        }
      })
    },
    DownloadPdfData ({ item }) {
      this.GETExportPdftSerice({ url: this.get_urls['inventario.transferencias.rpt'], replace: '{id}', params: item.id })
    },
    toApli (item) {
      this.SHOW_DIALOG_MAIN({
        type: 'apli',
        form: 'process',
        with: '50%',
        title: 'Documento de confirmacion',
        body: {
          objectMain: item,
          paramsDialog: {
            url: this.get_urls['transferencias.execute'],
            urloption: this.get_urls['transferencias.options'],
            message: 'tTransferencia correcta',
            returnObject: true,
            setmodel: false
          },
          method: 'form-data'
        }
      })
    },
    DowloadPdfData ({ item }) {
      this.GETExportPdftSerice({ url: '[ingresar url]' })
    }
  },

  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_objects', 'get_EditTransferenciasForm', 'get_sendDataView', 'get_filter_transferencia']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'filtro') {
        this.SHOW_DIALOG_MAIN({
          type: 'create',
          form: 'process',
          with: '80%',
          title: 'Nuevo Solicitud De Transferencia',
          body: {
            objectMain: { empresa_id: this.user.empresa_id },
            paramsDialog: {
              url: this.get_urls['transferencias.execute'],
              urloption: this.get_urls['transferencias.options'],
              message: 'Registro Agregado Correctamente',
              setmodel: true,
              setfilter: true,
              filter: model
            }
          }
        })
      }
    }
  }
}
</script>

<style >

</style>
